module.exports = __webpack_public_path__ + "static/media/upload-icon.ce7944aa.svg";